import router from "@/router"
import { Utils } from "@/plugins/utils"
import moment from "moment"
import Enums from "../../plugins/Enums"

export default {
	namespaced: true,
	state: {
		lstCv5: [],
		cv5DocTemp: "",
		lastValidatedInstallment: 99,
		lastStep: 0,
		lstCv7: [],
		cv5doc: "",
		sinceEmit: moment().format("YYYY-MM-DD 00:00"),
		untilEmit: moment().format("YYYY-MM-DD 23:59"),
		cv5EntSaiChipFiscalDocuments: [0, 1, 2, 3, 4],
		cv5EmitidoChipFiscalDocuments: [0, 1, 2, 3],
		cv5tipoFiscalDocuments: [],
		cv5clienteFiscalDocuments: [],
		cv5opercomFiscalDocuments: [],
		cv5emissorFiscalDocuments: [],
		cv5EntSaiChip: [0, 1],
		cv5EmitidoChip: [0, 1, 2],
		cv5cliente: "",
		cv5tipo: "",
		cv5opercom: "",
		cv5emissor: "",
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lastUpdatedRegister: null,
	},
	getters: {},
	mutations: {
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
		setCv5DocTemp(state, cv5DocTemp) {
			state.cv5DocTemp = cv5DocTemp
		},
		setParamsDataTable(state, payload) {
			state.lstCv5 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLstCv5(state, lstCv5) {
			state.lstCv5 = lstCv5
		},
		setSearch(state, search) {
			state.search = search
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		initForm(state) {
			state.insert = false
			state.update = false
		},
		setLstCv7(state, lstCv7) {
			state.lstCv7 = lstCv7
		},
		setCv5vend(state, cv5vend) {
			state.cv5vend = cv5vend
		},
		setCv5cliente(state, cv5cliente) {
			state.cv5cliente = cv5cliente
		}
	},
	actions: {
		async search({ commit, getters, dispatch, state }, { limit = 10, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")

			if (state.cv5EntSaiChip.length == 0) {
				state.cv5EntSaiChip = [0, 1]
			}
			let cv5EntSaiChip = ""
			for (const status of state.cv5EntSaiChip) {
				cv5EntSaiChip += "&cv5EntSaiChip=" + status
			}
			if (state.cv5EmitidoChip.length == 0) {
				state.cv5EmitidoChip = [0, 1, 2]
			}
			let cv5EmitidoChip = ""
			for (const status of state.cv5EmitidoChip) {
				cv5EmitidoChip += "&cv5EmitidoChip=" + status
			}

			let url = `/FiscalDocument/FiscalDocument/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`

			if (state.sinceEmit) {
				url += `&sinceEmit=${state.sinceEmit}`
			}
			if (state.untilEmit) {
				url += `&untilEmit=${state.untilEmit}`
			}

			url += `${cv5EntSaiChip}${cv5EmitidoChip}`

			if (state.cv5cliente && state.cv5cliente != "") {
				url += `&cv5cliente=${state.cv5cliente}`
			}
			if (state.cv5emissor && state.cv5emissor != "") {
				url += `&cv5emissor=${state.cv5emissor}`
			}
			if (state.cv5tipo && state.cv5tipo != "") {
				url += `&cv5tipo=${state.cv5tipo}`
			}
			if (state.cv5doc && state.cv5doc != "") {
				url += `&cv5doc=${state.cv5doc}`
			}
			if (state.cv5opercom && state.cv5opercom != "") {
				url += `&cv5opercom=${state.cv5opercom}`
			}

			let payload = await this._vm.$axios
				.get(url)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstCv5", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async searchFiscalDocuments({ commit, getters, dispatch, state }, { limit = 10, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")

			if (state.cv5EntSaiChipFiscalDocuments.length == 0) {
				state.cv5EntSaiChipFiscalDocuments = [0, 1, 2, 3, 4]
			}
			let cv5EntSaiChipFiscalDocuments = ""
			for (const status of state.cv5EntSaiChipFiscalDocuments) {
				cv5EntSaiChipFiscalDocuments += "&cv5EntSaiChip=" + status
			}
			if (state.cv5EmitidoChipFiscalDocuments.length == 0) {
				state.cv5EmitidoChipFiscalDocuments = [0, 1, 2, 3]
			}
			let cv5EmitidoChipFiscalDocuments = ""
			for (const status of state.cv5EmitidoChipFiscalDocuments) {
				cv5EmitidoChipFiscalDocuments += "&cv5EmitidoChip=" + status
			}

			let url = `/FiscalDocument/FiscalDocument/SearchFiscalDocuments?search=${getters.getSearch}&limit=${limit}&page=${page}`

			if (state.sinceEmit) {
				url += `&sinceEmit=${state.sinceEmit}`
			}
			if (state.untilEmit) {
				url += `&untilEmit=${state.untilEmit}`
			}

			url += `${cv5EntSaiChipFiscalDocuments}${cv5EmitidoChipFiscalDocuments}`

			if (state.cv5clienteFiscalDocuments.length > 0) {
				for(const chip of state.cv5clienteFiscalDocuments){
					url += `&cv5cliente=${chip}`
				}
			}
			if (state.cv5emissorFiscalDocuments.length > 0) {
				for(const chip of state.cv5emissorFiscalDocuments){
					url += `&cv5emissor=${chip}`
				}
			}
			if (state.cv5tipoFiscalDocuments.length > 0) {
				for(const chip of state.cv5tipoFiscalDocuments){
					url += `&cv5tipo=${chip}`
				}
			}
			if (state.cv5opercomFiscalDocuments.length > 0) {
				for(const chip of state.cv5opercomFiscalDocuments){
				url += `&cv5opercom=${chip}`
				}
			}

			if (state.cv5doc && state.cv5doc != "") {
				url += `&cv5doc=${state.cv5doc}`
			}

			let payload = await this._vm.$axios
				.get(url)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstCv5", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async emitBankSlipByOrder(store, { vd1pedido, print, isCrediario = false, redirect = true, reprint = false }) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Gerando boletos...", indeterminate: true },
				{ root: true },
			)

			let payload = await this._vm.$axios
				.post(
					`/FiscalDocument/BankSlip/EmitByOrder?vd1pedido=${vd1pedido}&lastValidatedInstallment=${store.state.lastValidatedInstallment}&lastStep=${store.state.lastStep}&print=${print}&isCrediario=${isCrediario}&reprint=${reprint}`,
				)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					if (payload.isError) {
						store.state.lastStep = payload.step
						store.state.lastValidatedInstallment = payload.installmentStep
						if (payload.step > 0 && payload.step < 3) {
							store.dispatch(
								"parameters/openDialog",
								{
									titleText: "Aviso",
									titleColor: "#f8bb86",
									text: payload.errorMessage,
									confirmBtn: true,
									confirmText: "Sim",
									confirmAction: async () => {
										store.state.lastStep++
										store
											.dispatch("emitBankSlipByOrder", { vd1pedido, print, isCrediario, reprint: true })
											.then(payload => {
												store.state.lastValidatedInstallment = 99
												store.state.lastStep = 0
											})
									},
									cancelText: "Não",
									cancelAction: () => {
										store.state.lastValidatedInstallment = 99
										store.state.lastStep = 0
										if (redirect) router.push("/oryxpdv/pedidos")
									},
								},
								{ root: true },
							)
						} else {
							throw new Error(payload.errorMessage)
						}
						return false
					}
					store.state.lastValidatedInstallment = 99
					store.state.lastStep = 0
					if (payload.relatsPath && payload.relatsPath.length > 0) {
						store.dispatch("print/openRelatsPath", payload.relatsPath, { root: true })
					}
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
							cancelAction: () => {
								if (redirect) router.push("/oryxpdv/pedidos")
							},
						},
						{ root: true },
					)

					store.state.lastValidatedInstallment = 99
					store.state.lastStep = 0

					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},

		async emitBankSlipByRegOp(
			store,
			{
				cv5doc,
				cv5tipo,
				cv5emissor,
				fn5agente,
				fn5conta,
				print,
				isCrediario = false,
				redirect = true,
				reprint = false,
			},
		) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Gerando boletos...", indeterminate: true },
				{ root: true },
			)

			let payload = await this._vm.$axios
				.post(
					`/FiscalDocument/BankSlip/EmitByRegOp?cv5doc=${cv5doc}&cv5tipo=${cv5tipo}&cv5emissor=${cv5emissor}&fn5agente=${fn5agente}&fn5conta=${fn5conta}&lastValidatedInstallment=${store.state.lastValidatedInstallment}&lastStep=${store.state.lastStep}&print=${print}&isCrediario=${isCrediario}&reprint=${reprint}`,
				)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					if (payload.isError) {
						store.state.lastStep = payload.step
						store.state.lastValidatedInstallment = payload.installmentStep
						if (payload.step > 0 && payload.step < 3) {
							store.dispatch(
								"parameters/openDialog",
								{
									titleText: "Aviso",
									titleColor: "#f8bb86",
									text: payload.errorMessage,
									confirmBtn: true,
									confirmText: "Sim",
									confirmAction: async () => {
										store.state.lastStep++
										store
											.dispatch("emitBankSlipByRegOp", {
												cv5doc,
												cv5tipo,
												cv5emissor,
												print,
												isCrediario,
												reprint: true,
											})
											.then(payload => {
												store.state.lastValidatedInstallment = 99
												store.state.lastStep = 0
											})
									},
									cancelText: "Não",
									cancelAction: () => {
										store.state.lastValidatedInstallment = 99
										store.state.lastStep = 0
										if (redirect) router.push("/oryxpdv/registro-de-operacoes")
									},
								},
								{ root: true },
							)
						} else {
							throw new Error(payload.errorMessage)
						}
						return false
					}
					store.state.lastValidatedInstallment = 99
					store.state.lastStep = 0
					if (payload.relatsPath && payload.relatsPath.length > 0) {
						store.dispatch("print/openRelatsPath", payload.relatsPath, { root: true })
					}
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
							cancelAction: () => {
								if (redirect) router.push("/oryxpdv/registro-de-operacoes")
							},
						},
						{ root: true },
					)

					store.state.lastValidatedInstallment = 99
					store.state.lastStep = 0

					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async sendNfeEmailByOrder(
			store,
			{
				order,
				ship,
				customReceiver = "",
				onlyXml = false,
				simplified = false,
				transporter = false,
				representative = false,
				silent = false,
			},
		) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Enviando nota e boleto por e-mail...", indeterminate: true },
				{ root: true },
			)

			let payload = await this._vm.$axios
				.post(
					`/FiscalDocument/FiscalDocument/SendNfeEmailByOrder?vd1pedido=${order}&ship=${ship}&customReceiver=${customReceiver}&onlyXml=${onlyXml}&simplified=${simplified}&transporter=${transporter}&representative=${representative}`,
				)
				.then(response => {
					let message = Utils.ValidateAxiosResponse(response.data)
					if (!silent) {
						store.dispatch(
							"parameters/openDialog",
							{
								titleText: message,
								titleColor: "green",
							},
							{ root: true },
						)
					}
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async find(store, { cv5doc, cv5tipo, cv5emissor }) {
			return await this._vm.$axios
				.get(`/FiscalDocument/FiscalDocument/Find/${cv5doc}/${cv5tipo}/${cv5emissor}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
				.finally(() => {
					store.state.update = true
					store.state.insert = false
				})
		},
		async EmitRegOpDocument(store, RegOpModel) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Emitindo documento", indeterminate: true },
				{ root: true },
			)

			let payload = await this._vm.$axios
				.post("/FiscalDocument/OperationRegister/EmitRegOpDocument", RegOpModel, {
					params: {
						forUpdate: store.state.update,
					},
				})
				.then(response => {
					const objectModel = response.data.objectModel
					store.commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					store.commit("setCv5DocTemp", objectModel[1])

					let relatPath = objectModel[0]
					store.dispatch("print/openRelatsPath", [relatPath], { root: true })

					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async SaveRegOpDocument(store, cv5) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando documento", indeterminate: true },
				{ root: true },
			)

			let payload = await this._vm.$axios
				.post("/FiscalDocument/OperationRegister/SaveRegOpDocument", cv5)
				.then(response => {
					const objectModel = response.data.objectModel
					store.commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					store.commit("setCv5DocTemp", objectModel)
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async UpdateRegOpDocument(store, UpdateRegOpModel) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Atualizando documento", indeterminate: true },
				{ root: true },
			)

			let payload = await this._vm.$axios
				.put("/FiscalDocument/OperationRegister/Update", UpdateRegOpModel)
				.then(response => {
					const objectModel = response.data.objectModel
					store.commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					store.commit("setCv5DocTemp", objectModel)
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async CancelRegOp({ dispatch }, cv5) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Cancelando documento", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/FiscalDocument/OperationRegister/CancelRegOp", cv5)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async printRegOpDocument(store, { cv5doc, cv5tipo, cv5emissor, download = false }) {
			let cv5 = {
				cv5doc: cv5doc,
				cv5tipo: cv5tipo,
				cv5emissor: cv5emissor,
			}
			store.dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: `${download ? "Baixando documentos" : "Imprimindo documentos"}`,
					indeterminate: true,
				},
				{ root: true },
			)
			await this._vm.$axios
				.post("/FiscalDocument/OperationRegister/PrintRegOpDocument", cv5)
				.then(response => {
					let relatsPath = Utils.ValidateAxiosResponse(response.data)
					if (relatsPath && relatsPath.length > 0) {
						if (download) store.dispatch("print/downloadFile", [relatsPath], { root: true })
						else store.dispatch("print/openRelatsPath", [relatsPath], { root: true })
					}

					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return true
		},
		async searchFiscalDocumentItems(store, { cv5doc, cv5tipo, cv5emissor }) {
			return await this._vm.$axios
				.get(`/FiscalDocument/FiscalDocument/SearchFiscalDocumentItems/${cv5doc}/${cv5tipo}/${cv5emissor}`)
				.then(response => {
					const payload = Utils.ValidateAxiosResponse(response.data)
					store.commit("setLstCv7", payload)
					return 

				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async findSeller(store, { cv5doc, cv5tipo, cv5emissor }) {
			return await this._vm.$axios
				.get(`/FiscalDocument/FiscalDocument/FindSeller/${cv5doc}/${cv5tipo}/${cv5emissor}`)
				.then(response => {
					const payload = Utils.ValidateAxiosResponse(response.data)
					store.commit("setCv5vend", payload.cv5vend)
					return 
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async canEditCommission(store, cv5opercom) {
			if (!cv5opercom) return false

			return await this._vm.$axios
				.get(`/FiscalDocument/FiscalDocument/CanEditCommission?cv5opercom=${encodeURIComponent(cv5opercom)}`)
				.then(response => {
					const payload = Utils.ValidateAxiosResponse(response.data)
					return payload
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async saveCommission(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando comissão", indeterminate: true },
				{ root: true },
			)

			const firstItem = store.state.lstCv7 && store.state.lstCv7.length ? store.state.lstCv7[0] : null

			const success = await this._vm.$axios
				.post("/FiscalDocument/FiscalDocument/SaveCommission", 
					{
						cv5vend: store.state.cv5vend,
						lstCv7: store.state.lstCv7
					} 
				)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})

			if (success && firstItem) {
				await store.dispatch("searchFiscalDocumentItems", {
					cv5doc: firstItem.cv7doc,
					cv5tipo: firstItem.cv7tipo,
					cv5emissor: firstItem.cv7emissor,
				})
			}

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return success
		},
		async changeCommisionByVendor(store, { vendor }) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Alterando a comissão", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
			.post(`/Representative/CommissionGrid/FindProducts/`, { veavend: vendor, veacliente: store.state.cv5cliente, lstCv7: store.state.lstCv7 })
			.then(response => {
				const payload = Utils.ValidateAxiosResponse(response.data)
				let lstCv7 = store.state.lstCv7.map(item => {
					const match = payload.find(payloadItem => payloadItem.veaproduto == item.cv7codigo)
					return match ? { ...item, ve6comis: match.veacomis } : item
				})
				store.commit("setLstCv7", lstCv7)
			})
			.catch(error => {
				store.dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				
				return null
			})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return true
		},
	},
}
